import React from 'react';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, PieChart, Pie } from "recharts";


const style = {
    textAlign: 'center'
}

const Body = ({ showBody, genderReport, mapGenderReport, ageReport, mapAgeReport, totalMembers }) => (
    <React.Fragment>
        {
            !showBody ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div >
                    <div className="clearfix">
                        <div className="col-lg-12 title_summary">
                            <h4 className="m-0 text-center text-justify text-white">Gender</h4>
                        </div>
                        <div className="col-lg-12 mt-2 d-flex">
                            {
                                <table style={{ minWidth: "35%" }}>
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Percentage</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Male</td>
                                            <td style={style}>{genderReport.find(x => x.type === 1) ? genderReport.find(x => x.type === 1).percentage.toFixed(2) : 0}%</td>
                                            <td style={style}>{genderReport.find(x => x.type === 1) ? genderReport.find(x => x.type === 1).amount : 0}</td>
                                        </tr>
                                        <tr>
                                            <td>Female</td>
                                            <td style={style}>{genderReport.find(x => x.type === 2) ? genderReport.find(x => x.type === 2).percentage.toFixed(2) : 0}%</td>
                                            <td style={style}>{genderReport.find(x => x.type === 2) ? genderReport.find(x => x.type === 2).amount : 0}</td>
                                        </tr>
                                        <tr>
                                            <td>Gender Non-Conforming</td>
                                            <td style={style}>{genderReport.find(x => x.type === 3) ? genderReport.find(x => x.type === 3).percentage.toFixed(2) : 0}%</td>
                                            <td style={style}>{genderReport.find(x => x.type === 3) ? genderReport.find(x => x.type === 3).amount : 0}</td>
                                        </tr>
                                        <tr>
                                            <td>Non-binary</td>
                                            <td style={style}>{genderReport.find(x => x.type === 4) ? genderReport.find(x => x.type === 4).percentage.toFixed(2) : 0}%</td>
                                            <td style={style}>{genderReport.find(x => x.type === 4) ? genderReport.find(x => x.type === 4).amount : 0}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: 'right' }}>
                                                <b>Total</b>
                                            </td>
                                            <td style={style}><b>{genderReport.reduce((total, currentValue) => total = total + currentValue.amount, 0)}</b></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            }
                            <ResponsiveContainer width="70%" height={300}>
                                <PieChart width={500} height={500}>
                                    <Pie isAnimationActive={false} data={mapGenderReport} dataKey="value" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label={({
                                        x, y, name
                                    }) => {
                                        return (
                                            <text x={x} y={y} fill="black" textAnchor={x > 400 ? "start" : "end"} dominantBaseline="central">
                                                {name}
                                            </text>
                                        );
                                    }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <br />
                    <div className="clearfix">
                        <div className="col-lg-12 title_summary">
                            <h4 className="m-0 text-center text-justify text-white">Age</h4>
                        </div>

                        <div className="col-lg-12 mt-2" style={{ display: 'flex' }}>
                            <table style={{ minWidth: "35%" }}>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Percentage</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Younger than 29</td>
                                        <td style={style}>{ageReport.find(x => x.type === 1) ? ageReport.find(x => x.type === 1).percentage.toFixed(2) : 0}%</td>
                                        <td style={style}>{ageReport.find(x => x.type === 1) ? ageReport.find(x => x.type === 1).amount : 0}</td>
                                    </tr>
                                    <tr>
                                        <td>Between 30 - 54</td>
                                        <td style={style}>{ageReport.find(x => x.type === 2) ? ageReport.find(x => x.type === 2).percentage.toFixed(2) : 0}%</td>
                                        <td style={style}>{ageReport.find(x => x.type === 2) ? ageReport.find(x => x.type === 2).amount : 0}</td>
                                    </tr>
                                    <tr>
                                        <td>Between 55 - 74</td>
                                        <td style={style}>{ageReport.find(x => x.type === 3) ? ageReport.find(x => x.type === 3).percentage.toFixed(2) : 0}%</td>
                                        <td style={style}>{ageReport.find(x => x.type === 3) ? ageReport.find(x => x.type === 3).amount : 0}</td>
                                    </tr>
                                    <tr>
                                        <td>Over 75</td>
                                        <td style={style}>{ageReport.find(x => x.type === 4) ? ageReport.find(x => x.type === 4).percentage.toFixed(2) : 0}%</td>
                                        <td style={style}>{ageReport.find(x => x.type === 4) ? ageReport.find(x => x.type === 4).amount : 0}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={2} style={{ textAlign: 'right' }}>
                                            <b>Total</b>
                                        </td>
                                        <td style={style}><b>{ageReport.reduce((total, currentValue) => total = total + currentValue.amount, 0)}</b></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <ResponsiveContainer width="70%" height={300}>
                                <PieChart width={500} height={500}>
                                    <Pie isAnimationActive={false} data={mapAgeReport} dataKey="value" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label={({
                                        x, y, name
                                    }) => {
                                        return (
                                            <text x={x} y={y} fill="black" textAnchor={x > 400 ? "start" : "end"} dominantBaseline="central" cx={{ padding: 50 }}>
                                                {name}
                                            </text>
                                        );
                                    }} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>

        }
    </React.Fragment>
);
export default Body;